import React, { useEffect, useState } from 'react';
import { Save, CheckCircle2 } from 'lucide-react';
import { seoApi } from '../../lib/api';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';

const pages = [
  { key: 'home',             label: 'Homepage' },
  { key: 'home-insurance',   label: 'Home Insurance' },
  { key: 'health-insurance', label: 'Health Insurance' },
  { key: 'about',            label: 'About' },
  { key: 'faq',              label: 'FAQ' },
  { key: 'blog',             label: 'Blog' },
  { key: 'contact',          label: 'Contact' },
];

export default function AdminSEO() {
  const [seo, setSeo] = useState({});
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => { seoApi.getAdmin().then(setSeo).catch(() => {}); }, []);

  const setField = (page, field, value) => {
    setSeo((s) => ({ ...s, [page]: { ...(s[page] || {}), [field]: value } }));
  };

  const save = async () => {
    setSaving(true); setSaved(false);
    try {
      await seoApi.update(seo);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } finally { setSaving(false); }
  };

  return (
    <div>
      <div className="mb-5">
        <h2 className="text-xl font-bold text-[#0b1f3a]">SEO settings</h2>
        <p className="text-slate-500 text-sm mt-1">Meta title, description and keywords for each page. Also used for social sharing.</p>
      </div>

      <div className="space-y-4">
        {pages.map((p) => {
          const v = seo[p.key] || {};
          const titleLen = (v.title || '').length;
          const descLen = (v.description || '').length;
          return (
            <div key={p.key} className="bg-white border border-slate-200 rounded-2xl p-6">
              <h3 className="font-semibold text-[#0b1f3a] mb-4">{p.label} <span className="text-slate-400 text-sm font-normal">/{p.key === 'home' ? '' : p.key}</span></h3>
              <div className="space-y-3">
                <div>
                  <div className="flex items-center justify-between">
                    <Label className="field-label">Meta title</Label>
                    <span className={`text-[11px] ${titleLen > 60 ? 'text-amber-600' : 'text-slate-400'}`}>{titleLen} / 60</span>
                  </div>
                  <Input value={v.title || ''} onChange={(e) => setField(p.key, 'title', e.target.value)} />
                </div>
                <div>
                  <div className="flex items-center justify-between">
                    <Label className="field-label">Meta description</Label>
                    <span className={`text-[11px] ${descLen > 160 ? 'text-amber-600' : 'text-slate-400'}`}>{descLen} / 160</span>
                  </div>
                  <Textarea rows={2} value={v.description || ''} onChange={(e) => setField(p.key, 'description', e.target.value)} />
                </div>
                <div>
                  <Label className="field-label">Keywords (comma separated)</Label>
                  <Input value={v.keywords || ''} onChange={(e) => setField(p.key, 'keywords', e.target.value)} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 flex items-center gap-3">
        <button onClick={save} disabled={saving} className="btn-primary disabled:opacity-60">
          <Save size={16} /> {saving ? 'Saving...' : 'Save all SEO settings'}
        </button>
        {saved && (
          <span className="inline-flex items-center gap-1.5 text-sm text-emerald-700">
            <CheckCircle2 size={16} /> Saved
          </span>
        )}
      </div>
    </div>
  );
}
